(function () {
  'use strict';
  // Only line-item properties are reorganized. Cart notes, billing attributes,
  // variant IDs, quantities and native gift-card delivery fields are untouched.
  const standard = ['Prodotto scelto', 'Formato scelto', 'Orientamento scelto', 'Design scelto', 'Supporto scelto'];
  const raw = new Set(['_ccl_crop', '_ccl_split_art', '_Ritaglio', '_Composizione DOGUE', '_ccl_art_id', '_ccl_preview_url', '_Stampa fronte', '_Stampa retro', '_Stampa_fronte', '_Stampa_retro', '_Istruzioni stampa', '_Modello biglietto']);
  const aliases = new Set(['Variante scelta', 'Formato stampa', 'Formato', 'Telaio', 'Bordo', 'Disegno', 'Colore', 'Design']);
  const fileOrder = ['Riepilogo Planner', 'Anteprima scelta', '_Fronte JPEG pronto stampa', '_Dedica retro JPEG pronto stampa', '_Biglietto JPEG pronto stampa', '_Sorgente disegno', 'Foto originale', 'Ritratto approvato', 'Ritaglio di riferimento', '_Polaroid pronta stampa', '_Biglietto pronto stampa', '_Anteprima carrello'];
  const value = v => typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : '';
  const text = (p, ...keys) => keys.map(k => value(p[k])).find(Boolean) || '';
  const blob = v => v instanceof Blob;
  const present = v => blob(v) ? v.size > 0 : v != null && String(v).trim() !== '';
  function specifications(p) {
    const source = text(p, 'Formato scelto', 'Formato stampa', 'Formato', 'Variante scelta');
    const match = source.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    const dimensions = match && match.slice(1).map(n => Number(n.replace(',', '.')));
    const size = dimensions ? dimensions.slice().sort((a, b) => a - b).join('×') + ' cm' : text(p, 'Formato scelto');
    const orientation = text(p, 'Orientamento scelto') || (/orizzontale/i.test(source) ? 'Orizzontale' : /verticale/i.test(source) ? 'Verticale' : dimensions ? dimensions[0] === dimensions[1] ? 'Quadrato' : dimensions[0] < dimensions[1] ? 'Verticale' : 'Orizzontale' : '');
    let support = text(p, 'Supporto scelto', 'Telaio');
    if (!support) support = /senza telaio|solo stampa/i.test(source) ? 'Solo stampa' : /con telaio/i.test(source) ? 'Telaio in legno' : '';
    if (/magnete|calamita/i.test(support + ' ' + source)) support = 'Calamita su legno con magnete';
    let design = text(p, 'Design scelto', 'Design', 'Disegno', 'Colore');
    if (design === 'Oro') design = 'Giallo';
    return { 'Formato scelto': size, 'Orientamento scelto': orientation, 'Design scelto': design, 'Supporto scelto': support };
  }
  function normalize(input) {
    const p = Array.isArray(input) ? Object.fromEntries(input) : { ...input };
    if (!Object.keys(p).length || p._ccl_order_clarity === '1' || p._ccl_voucher || p.__shopify_send_gift_card_to_recipient) return p;
    const details = { 'Prodotto scelto': text(p, 'Prodotto scelto'), ...specifications(p) };
    const gift = text(p, 'Per il quadro', '_Per articolo');
    if (gift && !details['Prodotto scelto']) details['Prodotto scelto'] = 'Confezione regalo con biglietto';
    if (gift) standard.slice(1).forEach(key => { delete details[key]; });
    const parts = standard.map(key => details[key]).filter(Boolean);
    if (gift) parts.push('Per ' + gift);
    const result = { 'Riepilogo ordine': parts.join(' · ') || text(p, 'Composizione', 'Confezione regalo') || 'Articolo personalizzato' };
    if (p.Composizione) result.Composizione = p.Composizione;
    if (p.Tela) result.Tela = p.Tela;
    const production = [];
    if (p['_Fronte JPEG pronto stampa']) production.push('Fronte: JPEG pronto stampa allegato');
    else if (p['_Sorgente disegno']) production.push('Disegno originale: collegamento allegato');
    if (p['_Dedica retro JPEG pronto stampa']) production.push('Retro: dedica JPEG allegata');
    if (p['_Biglietto JPEG pronto stampa']) production.push('Biglietto regalo: JPEG allegato');
    if (/^Richiesto/i.test(text(p, 'Intervento grafico'))) production.push('Intervento grafico da approvare prima della stampa');
    if (production.length) result['_Per il laboratorio'] = production.join(' · ');
    standard.forEach(key => { if (details[key]) result[key] = details[key]; });
    const archived = {};
    for (const [key, v] of Object.entries(p)) {
      if (raw.has(key) || aliases.has(key) || gift && standard.slice(1).includes(key) || key === '_Configurazione disegno' && !blob(v) && !/^https:\/\//i.test(value(v))) {
        archived[key] = v;
        continue;
      }
      if (!present(v) || standard.includes(key) || key === 'Riepilogo ordine' || key === 'Per il laboratorio' || key === '_Per il laboratorio' || fileOrder.includes(key)) continue;
      result[key] = v;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(value(result['Data evento']))) result['Data evento'] = result['Data evento'].split('-').reverse().join('/');
    if (/^#[0-9a-f]{6}$/i.test(value(result['Colore scritte']))) {
      const hex = result['Colore scritte'].toLowerCase();
      const named = { '#252e49': 'Blu Canvas', '#ffffff': 'Bianco', '#000000': 'Nero' }[hex];
      result['Colore scritte'] = named ? named + ' (' + hex + ')' : 'Colore personalizzato (' + hex + ')';
    }
    fileOrder.forEach(key => { if (present(p[key])) result[key] = p[key]; });
    // The original metadata remains lossless in one attachment, rather than
    // several long JSON strings in the merchant's order screen.
    if (Object.keys(archived).length) {
      const originals = Object.fromEntries(Object.entries(p).map(([key, v]) => [key, blob(v) ? { filename: v.name || 'file', type: v.type, bytes: v.size } : v]));
      const instructions = ['_Stampa fronte', '_Stampa_fronte', '_Stampa retro', '_Stampa_retro', '_Istruzioni stampa'].filter(key => present(p[key])).map(key => key.replace(/^_/, '') + ': ' + p[key]).join('\n');
      const heading = 'CANVAS CREATION LAB — DATI LABORATORIO\n\n' + result['Riepilogo ordine'] + '\n\nI file JPEG allegati alla riga ordine sono i file di stampa. Anteprima scelta è solo un riferimento.\n\n' + instructions + '\n\nDATI ORIGINALI INTEGRALI\n\n';
      const attachment = new File([heading, JSON.stringify({ version: 1, originalProperties: originals }, null, 2)], 'Canvas-dati-laboratorio.txt', { type: 'text/plain;charset=utf-8' });
      // Keep the existing catalog signal and the Planner's original manifest.
      if (!present(result['_Configurazione disegno'])) result['_Configurazione disegno'] = attachment;
      else result['_Dati laboratorio'] = attachment;
    }
    result._ccl_order_clarity = '1';
    return result;
  }
  function prepareBody(body) {
    const groups = new Map();
    const expected = [];
    for (const [name, v] of body) {
      const m = name.match(/^(items\[\d+\]\[properties\]|properties)\[(.+)\]$/);
      if (!m) continue;
      if (!groups.has(m[1])) groups.set(m[1], {});
      groups.get(m[1])[m[2]] = v;
    }
    for (const [prefix, original] of groups) {
      const normalized = normalize(original);
      const idKey = prefix === 'properties' ? 'id' : prefix.replace('[properties]', '[id]');
      expected.push({ id: body.get(idKey), properties: normalized });
      Object.keys(original).forEach(key => body.delete(prefix + '[' + key + ']'));
      for (const [key, v] of Object.entries(normalized)) {
        const name = prefix + '[' + key + ']';
        if (blob(v)) body.append(name, v, v.name || 'allegato');
        else body.append(name, String(v));
      }
    }
    body.cclOrderExpected = expected;
    return body;
  }
  function verify(data, body) {
    const lines = data.items || [data];
    for (const item of body.cclOrderExpected || []) {
      if (!lines.some(line => String(line.id) === String(item.id) && Object.entries(item.properties).every(([key, v]) => blob(v) ? /^https:\/\//.test(line.properties?.[key] || '') : String(line.properties?.[key] ?? '') === String(v)))) {
        throw Error('L’articolo potrebbe essere nel carrello, ma il riepilogo o un allegato non è stato confermato. Controlla il carrello prima di riprovare.');
      }
    }
  }
  window.CCLOrderDetails = { normalize, prepareBody, verify };
})();

/* Static cart fronts reuse the product's exact format and crop, without mounting 3D. */
(function(){
  'use strict';
  const records=new Map(),renders=new Map();
  const names=['Anteprima scelta','_Anteprima carrello','_Polaroid pronta stampa','_Fronte JPEG pronto stampa','Ritaglio di riferimento','Ritratto approvato','Foto originale'];
  function properties(value){return Array.isArray(value)?Object.fromEntries(value):value||{};}
  function source(value){const data=properties(value);for(const name of names){const value=data[name];if(typeof value==='string'&&/^https?:\/\//i.test(value))return value;}const card=data['_Biglietto JPEG pronto stampa'];return (data['Per il quadro']||data['_Per articolo'])&&typeof card==='string'&&/^https?:\/\//i.test(card)?card:null;}
  async function thumbnail(front){
    const canvas=document.createElement('canvas'),scale=Math.min(1,360/Math.max(front.width,front.height));
    canvas.width=Math.max(1,Math.round(front.width*scale));canvas.height=Math.max(1,Math.round(front.height*scale));
    const ctx=canvas.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.drawImage(front,0,0,canvas.width,canvas.height);
    const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/jpeg',.84));
    if(!blob)throw Error('Impossibile preparare la miniatura. Riprova.');
    return new File([blob],'anteprima-carrello.jpg',{type:'image/jpeg'});
  }
  function selection(item,record){
    if(item.variant?.orientation)return item.variant;
    const id=item.variant_id||item.id||record.variant.id,raw=item.variant_options?{id,options:item.variant_options}:record.variant;
    const variants=window.CCLCatalog.normalize([raw],record.options,record.config),design=properties(item.properties)['_Design variante']||properties(item.properties)['Design scelto']||properties(item.properties).Disegno;
    return variants.find(v=>String(v.id)===String(id)&&(!design||v.option2===design))||variants.find(v=>String(v.id)===String(id));
  }
  function load(src){return new Promise((resolve,reject)=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=reject;img.src=src;});}
  async function canvasFront(item,record){
    const v=selection(item,record);if(!v)return null;
    const [w,h]=v.option1.split('x').map(Number);if(!(w>0&&h>0))return null;
    let split;try{split=JSON.parse(properties(item.properties)._ccl_split_art||'null');}catch(_){}
    const descriptor=window.CCLCatalog.source(record.config,v);
    const src=split?.version===1&&split.cropUnit==='normalized_xywh'?split.source?.src:descriptor?.src;
    if(!src)return null;
    const key=JSON.stringify([src,w,h,descriptor,split?.crop]);
    if(!renders.has(key)){
      if(renders.size>=80)renders.clear();
      const job=load(src).then(img=>{
        let crop=descriptor?.crop;
        if(split?.cropUnit==='normalized_xywh'&&Array.isArray(split.crop)&&split.crop.length===4&&split.crop.every(Number.isFinite)){
          const [x,y,cw,ch]=split.crop;if(x<0||y<0||cw<=0||ch<=0||x+cw>1.00001||y+ch>1.00001)return null;
          crop=[x*img.naturalWidth,y*img.naturalHeight,(x+cw)*img.naturalWidth,(y+ch)*img.naturalHeight];
        }
        const fitted=window.CCLCatalog.fittedArtwork(img,w,h,crop,360,descriptor?.fit,descriptor?.focusYBySize?.[v.option1]??descriptor?.focusY,descriptor?.focusXBySize?.[v.option1]??descriptor?.focusX);
        return fitted.image;
      }).catch(()=>{renders.delete(key);return null;});
      renders.set(key,job);
    }
    return renders.get(key);
  }
  async function front(item,record){const canvas=await canvasFront(item,record);return canvas?canvas.toDataURL('image/jpeg',.84):null;}
  function details(title,variant){
    const result={'Prodotto scelto':String(title||'').trim()};
    const dimensions=String(variant?.option1||variant?.title||'').match(/(\d+)\s*[x×]\s*(\d+)/i);
    if(dimensions){const [w,h]=dimensions.slice(1).map(Number);result['Formato scelto']=[w,h].sort((a,b)=>a-b).join('×')+' cm';result['Orientamento scelto']=w===h?'Quadrato':w<h?'Verticale':'Orizzontale';}
    if(variant?.option2)result['Design scelto']=variant.option2==='Oro'?'Giallo':variant.option2;
    if(variant?.option3)result['Supporto scelto']=variant.option1==='7x7'?'Calamita':variant.option3.includes('Senza Telaio')?'Solo stampa':variant.option3.includes('Con Telaio')?'Telaio in legno · 2 cm':variant.option3;
    return Object.fromEntries(Object.entries(result).filter(([,value])=>value));
  }
  async function prepare(item,record){
    const v=selection(item,record);
    if(!v||!record?.config?.artwork)throw Error('Impossibile confermare il disegno scelto. Ricarica la pagina.');
    const canvas=await canvasFront(item,record);
    if(!canvas)throw Error('Impossibile preparare l’anteprima del disegno. Riprova.');
    const descriptor=window.CCLCatalog.source(record.config,v);
    return {...item,properties:{...details(record.config.name||record.title,v),...properties(item.properties),
      'Design scelto':v.option2==='Oro'?'Giallo':v.option2,'_Design variante':v.option2,
      'Anteprima scelta':await thumbnail(canvas),
      '_Sorgente disegno':descriptor.src,
      '_Configurazione disegno':JSON.stringify({version:1,variantId:String(v.id),size:v.option1,design:v.option2,support:v.option3,source:descriptor,split:properties(item.properties)._ccl_split_art||null})}};
  }
  function append(body,item,index){
    item.properties=window.CCLOrderDetails.normalize(properties(item.properties));
    const prefix='items['+index+']';body.append(prefix+'[id]',item.id);body.append(prefix+'[quantity]',item.quantity||1);
    Object.entries(properties(item.properties)).forEach(([name,value])=>{if(value instanceof Blob)body.append(prefix+'[properties]['+name+']',value,value.name||'anteprima.jpg');else if(value!=null)body.append(prefix+'[properties]['+name+']',value);});
  }
  function verify(data,items){
    const added=data.items||[data];
    for(const item of items){const uploaded=Object.entries(properties(item.properties)).filter(([,v])=>v instanceof Blob).map(([name])=>name);
      if(uploaded.length&&!added.some(line=>String(line.id)===String(item.id)&&Object.entries(properties(item.properties)).every(([key,value])=>value instanceof Blob?/^https:\/\//.test(line.properties?.[key]||''):String(line.properties?.[key]??'')===String(value??''))))throw Error('L’articolo potrebbe essere nel carrello, ma l’anteprima non è stata confermata. Controlla il carrello prima di riprovare.');
    }
  }
  async function imageThumbnail(src){return thumbnail(await load(src));}
  async function fileThumbnail(file){const url=URL.createObjectURL(file);try{return await imageThumbnail(url);}finally{URL.revokeObjectURL(url);}}
  async function add(items){
    const body=new FormData();items.forEach((item,index)=>append(body,item,index));
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
    const data=await response.json();if(!response.ok)throw Error(typeof data.description==='string'?data.description:'Impossibile aggiungere al carrello.');verify(data,items);return data;
  }
  function decorate(img,item){img.classList.add('ccl-cart-preview');img.alt=properties(item.properties)['Prodotto scelto']||item.product_title||item.product?.title||item.title||img.alt;img.style.objectFit='contain';img.style.height='auto';img.removeAttribute('srcset');img.classList.remove('hide');}
  async function paint(img,item,record){
    const token={};img.cclCartToken=token;
    const url=source(item.properties);
    if(url){decorate(img,item);img.src=url;return;}
    if(!window.CCLCatalog||!record?.config?.artwork)return;
    const rendered=await front(item,record);
    if(rendered&&img.cclCartToken===token){decorate(img,item);img.src=rendered;}
  }
  function read(scope){scope.querySelectorAll('[data-ccl-cart-record]').forEach(el=>{try{const record=JSON.parse(el.textContent);records.set(record.key,record);}catch(_){} });}
  function refresh(scope,items){
    const rows=scope.querySelectorAll('[data-cart-item]');
    rows.forEach(row=>{
      const key=row.dataset.cartItemKey,record=records.get(key),item=items?.find(i=>i.key===key)||record;
      const title=row.querySelector('[data-cart-item-title]'),chosen=properties(item?.properties)['Prodotto scelto'];if(title&&chosen&&title.firstChild?.nodeType===3)title.firstChild.textContent=chosen;
      if(properties(item?.properties)['_Configurazione disegno'])row.querySelectorAll('.product-details__item--variant-option').forEach(el=>el.hidden=true);
      const img=row.querySelector('[data-cart-item-image]');if(item&&img)paint(img,item,record);
    });
  }
  function init(scope){read(scope);refresh(scope);}
  window.CCLCartImages={source,thumbnail,paint,front,refresh,details,prepare,append,verify,add,imageThumbnail,fileThumbnail};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

